import { type ClassValue, clsx } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Utility function to merge Tailwind classes with conflict resolution
 * Used throughout shadcn/ui components for className composition
 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
} 